import { apiFetch, ensureCsrf } from './client';
import type { SessionUser } from '@/types';

export interface LoginBody {
  email: string;
  password: string;
  role: 'admin' | 'admin_employee' | 'vendor' | 'vendor_employee';
  remember?: boolean;
}

export async function login(body: LoginBody): Promise<SessionUser> {
  const csrf = await ensureCsrf();
  const res = await apiFetch<{ data: SessionUser }>('/session/login', {
    method: 'POST',
    body: JSON.stringify(body),
    headers: csrf?.token ? { 'X-CSRF-TOKEN': csrf.token } : undefined,
  });
  return res.data;
}

export async function logout(): Promise<void> {
  await apiFetch('/session/logout', { method: 'POST' });
}

export async function currentUser(): Promise<SessionUser | null> {
  try {
    const res = await apiFetch<{ data: SessionUser }>('/session/user');
    return res.data;
  } catch {
    return null;
  }
}
